/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

// Remove multiple items from the cart (all variants in a recharge bundle)
async function multipleCartItemRemove(variantIds) {
  array = variantIds.split(',');
  array.pop();
  updates = {};
  array.forEach(element => updates[element] = 0);

  await fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ updates: updates }),
  }).then(cart => {
    var cartItemCounter = document.querySelector('span.header__cart__status');        
    itemCount = parseInt(cartItemCounter.dataset['cartCount']) - 1;

    window.cart.getCart(itemCount);
  });
}

(function() {  

   // Function to load the recharge SDK via a promise so we can initialize it after
  function loadScript(scriptUrl) {
    const script = document.createElement('script');
    script.src = scriptUrl;
    document.body.appendChild(script);
    
    return new Promise((res, rej) => {
      script.onload = function() {
        res();
      }
      script.onerror = function () {
        rej();
      }
    });
  }

  // Initialize recharge
  async function initRecharge() {    
    recharge.init({
      storeIdentifier: '23c817.myshopify.com',
      storefrontAccessToken: 'strfnt_e73d6684b7bc6aeb863edea94a47ec742f5a9ef9a2643d7e88cbd2da66135e79',
    });

    // Get the selling plan id for 30 days recurring using the recharge SDK for each product and store it in the products array
    i = 0;
    for (const product of recommendedProducts) {
      let cdnProduct = await recharge.cdn.getCDNProduct(product.id);
      let sellingPlan = cdnProduct['selling_plan_groups'][0]['selling_plans'][0]['selling_plan_id'];
      
      recommendedProducts[i]['selling_plan'] = sellingPlan;
      i++;
    }
  }
  
  let recommendedProducts = [];

  // Presidio Quizkit - callback for Quiz Results Page Loaded -> Store the recommended products
  document.addEventListener("quizKitResultsPageLoaded", function(e) {
    recommendedProducts = e.detail.recommendedProducts;
  }, false);

  // Presidio Quizkit - callback for Quiz Results Page Rendered -> Send dynamic bundle to ReCharge
  document.addEventListener('quizKitResultsPageRendered', function(e) {
    loadScript('https://static.rechargecdn.com/assets/storefront/recharge-client-1.0.1.min.js')
      .then(() => initRecharge())

    // Create the button
    const button = document.createElement('button');
    button.textContent = 'Add to cart';
    button.style.cssText = 'width:auto;height:41px;line-height:1;padding:13px 16px;border-radius:0px;min-width:160px;font-size:15px;font-family:Avenir-Medium;letter-spacing:1px;font-weight:500;color:rgb(255, 255, 255);background-color: rgb(238, 89, 48);border: 1px solid rgb(238, 89, 48);';
    button.setAttribute('font-weight', 500);
    button.setAttribute('letter-spacing', 1);
    button.setAttribute('font-size', 15);
    button.setAttribute('font-family', 'Avenir-Medium');
    button.setAttribute('kind', 'fill');
    button.setAttribute('height', '41px');

    // Create parent div to center it
    const div = document.createElement('div');
    div.style.cssText = 'text-align:center;';
    div.appendChild(button);   

    // Set the onclick for the button
    button.addEventListener('click', async () => {
      const variantId = '44816752771380';

      let selection = {
        externalVariantId: variantId,
        externalProductId: '8215654531380',
      };

      const collectionId = '439682105652';
      
      let selections = [];

      // Add the selected products to the data to send to recharge
      recommendedProducts.forEach((product) => {
        selections.push({
          collectionId: collectionId,
          externalProductId: `${product.id}`,
          externalVariantId: `${product.variants[0].id}`,
          quantity: `${product['variants'][0]['quantity']}`,
          sellingPlan: `${product.selling_plan}`,
        });
      });

      selection['selections'] = selections;      

      // Get the dynamic bundle items to be added to the cart
      const items = await recharge.bundle.getDynamicBundleItems(selection, 'binto-monthly-kit');

      // Add the dynamic bundle items to the cart
      await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: items }),
      }).then(cart => {
        var cartItemCounter = document.querySelector('span.header__cart__status');
        
        if (cartItemCounter == null) {
          itemCount = 1;
        } else {
          itemCount = parseInt(cartItemCounter.dataset['cartCount']) + 1;
        }

        window.cart.getCart(itemCount);
      });
    });

    // Append the button to the quizkit container
    const container = document.getElementById('quiz-kit-sections-container');
    container.lastChild.appendChild(div);
  }, false);

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

$('.tab_heading').click(function(){
    $(this).parent().find('.tabs_cont').toggleClass('open_pro_tab');
    $(this).parent().siblings().find('.tabs_cont').removeClass('open_pro_tab');
});


// New Text Image Slider
